export default "__VITE_ASSET__pSfhEU_1__"